import { Controller } from "@hotwired/stimulus"

// When the default icon pack select changes on App Icons edit, reload the
// turbo-frame so previews / "Overridden" badges / remove checkboxes match the
// newly selected pack (overrides are pack-scoped).
export default class extends Controller {
  static values = { url: String }

  change(event) {
    const pack = event.target.value
    if (!pack || !this.hasUrlValue) return

    const frame = this.element.closest("turbo-frame")
    if (!frame) return

    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("icon_pack", pack)
    frame.src = url.toString()
  }
}
